<div class="image-upload-container">
  <!-- Image Preview -->
  <div class="image-preview" *ngIf="!uploading">
    <div class="checkered-background">
      <img [src]="value ? (value + (value.includes('?') ? '&' : '?') + 't=' + imageTimestamp) : 'assets/img/crchat-logo-square.png'"
           [alt]="value ? 'Current image' : 'Default logo'"
           [style.width.px]="previewSize"
           [style.height.px]="previewSize">
    </div>
  </div>

  <!-- Drag and Drop Upload Area -->
  <div class="image-upload-area p-2" 
       [class.drag-over]="dragOver"
       [class.uploading]="uploading"
       [class.disabled]="disabled"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)"
       (click)="triggerFileInput()">
    
    <div class="upload-content" *ngIf="!uploading">
      <p class="upload-text">
        <strong>{{config.dropText}}</strong>
      </p>
    </div>
    
    <div class="upload-progress" *ngIf="uploading">
      <div class="progress-circle">
        <svg width="60" height="60">
          <circle cx="30" cy="30" r="25" fill="none" stroke="#e5e5e5" stroke-width="4"/>
          <circle cx="30" cy="30" r="25" fill="none" stroke="#0078d4" stroke-width="4"
                  [attr.stroke-dasharray]="157" 
                  [attr.stroke-dashoffset]="157 - (157 * uploadProgress / 100)"
                  style="transform: rotate(-90deg); transform-origin: 30px 30px;"/>
        </svg>
        <span class="progress-text">{{uploadProgress}}%</span>
      </div>
      <p>Uploading image...</p>
    </div>
  </div>
  
  <!-- Hidden file input -->
  <input type="file"
         [id]="inputId"
         [accept]="config.allowedTypes?.join(',')"
         style="display: none;"
         [disabled]="disabled || uploading"
         (change)="onFileSelected($event)">
</div>